import { render, staticRenderFns } from "./SplitSelector.vue?vue&type=template&id=fa935d48&scoped=true"
import script from "./SplitSelector.vue?vue&type=script&lang=js"
export * from "./SplitSelector.vue?vue&type=script&lang=js"
import style0 from "./SplitSelector.vue?vue&type=style&index=0&id=fa935d48&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa935d48",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\cxy\\project\\zcy\\zcy-dataEase\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fa935d48')) {
      api.createRecord('fa935d48', component.options)
    } else {
      api.reload('fa935d48', component.options)
    }
    module.hot.accept("./SplitSelector.vue?vue&type=template&id=fa935d48&scoped=true", function () {
      api.rerender('fa935d48', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/chart/components/componentStyle/SplitSelector.vue"
export default component.exports